import { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import ShareModal from './SharePopup'

export const ShareButton = ({ title }) => {
  const [modalIsOpen, setIsOpen] = useState(false)

  const handleClick = () => {
    setIsOpen(true)
  }

  const closeModal = (e) => {
    e.stopPropagation()
    setIsOpen(false)
  }

  return (
    <div className='dive-site-header__share'>
      <button
        className='dive-site-header__text dive-site-header__btn'
        onClick={handleClick}
        data-navigation-elements='data-navigation-elements'
        data-region-identifier='share'
      >
        <i className='font-icons icon-share-dg' />
        &nbsp;
        <FormattedMessage id='share' defaultMessage='Share' />
      </button>
      <ShareModal title={title} isOpen={modalIsOpen} onClose={closeModal} />
    </div>
  )
}
